module.exports = __webpack_public_path__ + "img/green-2.e26cec81.svg";